import React, { useContext, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';

const UpgradeTooltip: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  return (
    <SimpleTooltip
      placement={isMobile ? 'top' : 'right'}
      offsetModifier={isMobile ? [0, 10] : [10, 10]}
      text={t('deviationSubmit.form.section.sell.title.upgradeTooltip')}
      usePortal
    >
      {children}
    </SimpleTooltip>
  );
};
UpgradeTooltip.displayName = 'UpgradeTooltip';

export default UpgradeTooltip;
